import React, { useEffect, useState, useContext, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import ReactTable from 'Components/ReactTable/ReactTable';
import {
    Container,
    Grid,
    Paper,
    CircularProgress,
    MenuItem
} from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import InputLabel from 'Components/Inputes/InputLabel';
import AsyncAutoComplete from 'Components/Inputes/AsyncAutoComplete';
import { SelectDownlinForDropDown as USER_SELECT_DOWNLINE } from 'Components/Api/UsersApi';
import { SelectByWalletIDAndReceiverID as WALLET_INFO } from 'Components/Api/WalletApi';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Reverse as CASH_COLLECT_REVERSE,
    SelectByUserID as SELECT_BY_USERID
} from 'Components/Api/CashCollectionAPI';
import { Select as SELECT_PAYMENT_MODE } from 'Components/Api/PaymentModesAPI';

import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { BalanceContext } from 'Components/BalanceContext';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);
export const CashCollectionReverse = () => {
    const formRef = useRef();
    const { DashboardBalanceUpdate } = useContext(BalanceContext);
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [paymentModes, setpaymentModes] = useState([]);
    const [downline, setDownline] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [cashCollectionList, setCashCollectionList] = useState([]);
    const [UserInfo, setUserInfo] = useState('');
    const [TakeCount] = useState(10);
    const [SkipCount] = useState(0);
    const [downlineUserID, setDownlineUserID] = useState(0);
    const [userDefault, setUserDefault] = useState({
        UserID: 0,
        FirmName: 'Select Receiver'
    });

    const [formObj, setFormObj] = useState({
        ReceiverID: userDefault,
        Amount: '',
        AmountInWords: '',
        Remark: '',
        PayMode: ''
    });

    const validationSchema = Yup.object({
        User: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'User')
            .required(PLEASE_SELECT_VALID + 'User')
            .shape({
                UserID: Yup.string()
                    .notOneOf(['0'], PLEASE_SELECT_VALID + 'User')
                    .required(PLEASE_SELECT_VALID + 'User')
            }),

        Amount: Yup.number()
            .moreThan(0, PLEASE_PROVIDE_VALID + 'amount')
            .required(PLEASE_PROVIDE_VALID + 'amount'),

        Remark: Yup.string().required(PLEASE_PROVIDE_VALID + 'remark'),

        PayMode: Yup.string().required(PLEASE_PROVIDE_VALID + 'PayMode')
    });

    const selectPaymentModes = async () => {
        const response = await SELECT_PAYMENT_MODE();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        setpaymentModes(data);
    };

    const PayModeList = paymentModes.map(({ PaymentModeMasterID, Type }) => (
        <MenuItem key={PaymentModeMasterID} value={Type}>
            {Type}
        </MenuItem>
    ));

    const callSearch = async (text) => {
        if (
            text === undefined ||
            text === null ||
            text === '' ||
            text.length <= 0 ||
            text === userDefault.FirmName
        )
            return;

        var jsonObj = {
            FirmName: text
        };
        selectDownline(jsonObj);
    };

    const selectDownline = async (values) => {
        setLoadingOpen(true);
        var request = JSON.stringify(values);
        setLoadingOpen(false);
        const { isAuthorized, status, data } = await USER_SELECT_DOWNLINE(
            request
        );

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setResponseMessage(data);
            setIsError(true);
        }

        setDownline(JSON.parse(data));
    };

    const SelectCashCollectionReportByUserID = async (UserID) => {
        setDownlineUserID(UserID);
        var request = {
            TakeCount: TakeCount,
            SkipCount: SkipCount,
            UserID: UserID
        };

        setLoadingOpen(true);
        var json = JSON.stringify(request);
        const { isAuthorized, status, data } = await SELECT_BY_USERID(json);

        setLoadingOpen(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            return;
        }

        let d = JSON.parse(data);
        createColumns();

        setCashCollectionList(d.data);
    };

    const selectDownlineBalanceInformation = async (
        ReceiverID,
        setFieldValue
    ) => {
        if (ReceiverID <= 0) return;

        var request = {
            WalletID: 1,
            ReceiverID: ReceiverID
        };

        setLoadingOpen(true);
        var json = JSON.stringify(request);

        const response = await WALLET_INFO(json);

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setSeverity('error');
            setIsError(true);
            return;
        }

        const { Outstanding, BalanceDetail } = JSON.parse(response.data);
        setUserInfo(BalanceDetail);
        setFieldValue('Info', 'OS:' + Outstanding);
    };

    useEffect(() => {
        createColumns();
        selectPaymentModes();
    }, []);
    const createColumns = () => {
        var columns = [];
        var textwrapwidth = 80;
        columns.push({
            label: '#',
            name: 'SRNO',
            srno: true
        });
        columns.push({
            label: 'Date',
            name: 'Date'
        });
        columns.push({
            label: 'FirmName',
            name: 'FirmName'
        });

        columns.push({
            label: 'Receive',
            name: 'AssignedUserName'
        });
        columns.push({
            label: 'Opening OS',
            name: 'OpeningBalance',
            textwrapwidth,
            numeric: true
        });
        columns.push({
            label: 'CollectionAmount',
            name: 'Amount',
            textwrapwidth,
            numeric: true
        });
        columns.push({
            label: 'Closing Os',
            name: 'ClosingBalance',
            textwrapwidth,
            numeric: true
        });
        columns.push({
            label: 'PayMode',
            name: 'PayMode'
        });
        columns.push({
            label: 'Remark',
            name: 'Remark'
        });

        setMainColumns(columns);
    };
    const updateReceiverID = async (value, setFieldValue) => {
        setFieldValue('ReceiverID', value.UserID);
        setUserDefault({
            UserID: value.UserID,
            FirmName: value.FirmName
        });
        await SelectCashCollectionReportByUserID(value.UserID);
        await selectDownlineBalanceInformation(value.UserID, setFieldValue);
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setLoadingOpen(true);

        var response = await CASH_COLLECT_REVERSE(JSON.stringify(values));

        if (!response.isAuthorized) LOGOUT();

        DashboardBalanceUpdate();
        setLoadingOpen(false);
        setSubmitting(false);
        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }
        setIsError(true);
        setResponseMessage(response.data);
        setSeverity('success');

        if (downlineUserID !== 0) {
            await SelectCashCollectionReportByUserID(downlineUserID);
        }
        resetForm(formObj);
        reset();
        setUserInfo('');
    };

    const OnCashCollectionAmountChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) return;

        setFieldValue('AmountInWords', NumberToWord(value));
    };
    const reset = () => {
        setUserInfo('');
        setUserDefault({
            UserID: 0,
            FirmName: 'Select User'
        });
        setFormObj({
            ReceiverID: userDefault,
            Amount: '',
            AmountInWords: '',
            Remark: ''
        });
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                key={'formTransfer'}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                resetForm={formObj}
                render={({ values, setFieldValue, resetForm }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Cash Collection Reverse
                            </h2>
                            <Paper className={classes.PaperStyle}>
                                <Grid container item spacing={2}>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <Field
                                            component={AsyncAutoComplete}
                                            defaultValue={userDefault}
                                            FieldName="User"
                                            name="User"
                                            SubFieldName="UserID"
                                            options={downline}
                                            getOptionLabel={(option) =>
                                                option.FirmName
                                            }
                                            textFieldProps={{
                                                label: 'Select Receiver'
                                            }}
                                            onSearchCallback={(text) => {
                                                callSearch(text);
                                            }}
                                            onCustomCallback={(name, value) => {
                                                updateReceiverID(
                                                    value,
                                                    setFieldValue
                                                );
                                            }}
                                        />
                                        <InputLabel
                                            color="green"
                                            value={UserInfo}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialCurrency
                                            name="Amount"
                                            label="Collection Amount"
                                            placeholder="Amount"
                                            autoComplete="new-password"
                                            max={999999}
                                            onCustomCallback={(value) => {
                                                OnCashCollectionAmountChange(
                                                    value,
                                                    setFieldValue
                                                );
                                            }}
                                        />
                                        <InputLabel
                                            color="green"
                                            value={values.AmountInWords}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialTextField
                                            label="Collection Remark"
                                            name="Remark"
                                            type="text"
                                            length={150}
                                            title="Collection Remark"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialSelect
                                            label="Pay Mode"
                                            name="PayMode"
                                            title="Select Mode"
                                        >
                                            <MenuItem key="0" value="0">
                                                Select Mode
                                            </MenuItem>
                                            {PayModeList}
                                        </MaterialSelect>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <PrimaryButton
                                            type="submit"
                                            title="Reverse"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loadingOpen}
                                        >
                                            Reverse
                                        </PrimaryButton>
                                        {loadingOpen && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <SecondaryButton
                                            type="reset"
                                            title="Reset"
                                            onClick={() => {
                                                reset();
                                            }}
                                            className={
                                                classes.CustomDangerButtonStyle
                                            }
                                        >
                                            Reset
                                        </SecondaryButton>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Form>
                    );
                }}
            />
            <h2 className={classes.PaperHead_h2}>Report</h2>
            <ReactTable
                data={cashCollectionList}
                rowsPerPage={100}
                columns={mainColumns}
            />
        </CustomContainer>
    );
};
